import { render, staticRenderFns } from "./Nomore.vue?vue&type=template&id=4846ae89&scoped=true"
import script from "./Nomore.vue?vue&type=script&lang=js"
export * from "./Nomore.vue?vue&type=script&lang=js"
import style0 from "./Nomore.vue?vue&type=style&index=0&id=4846ae89&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4846ae89",
  null
  
)

export default component.exports